'use client'

import { usePathname, useRouter, useSearchParams } from 'next/navigation'
import { useCallback } from 'react'

/** The query parameter that opens the assistant on a conversation, as in a link copied with "Share". */
const CONVERSATION_PARAM = 'assistantConversation'

export function conversationLink(conversationId: string): string {
  const url = new URL(window.location.href)
  url.searchParams.set(CONVERSATION_PARAM, conversationId)
  return url.toString()
}

/**
 * The conversation the current URL links to, on first load or after a client-side navigation, and `clear`, which
 * drops the parameter once the panel has opened it so a reload or another link opens it afresh.
 */
export function useLinkedConversation() {
  const router = useRouter()
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const linkedConversationId = searchParams.get(CONVERSATION_PARAM) ?? undefined

  const clear = useCallback(() => {
    const params = new URLSearchParams(searchParams)
    params.delete(CONVERSATION_PARAM)
    const query = params.toString()
    router.replace(query ? `${pathname}?${query}` : pathname, { scroll: false })
  }, [pathname, router, searchParams])

  return { linkedConversationId, clear }
}
